import {Component, inject, Input} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {CopilotService} from '../../../../../services/copilot.service';

@Component({
  selector: 'app-copilot-followup-questions-message',
    imports: [
        NgForOf,
        NgIf
    ],
  templateUrl: './copilot-followup-questions-message.component.html',
  styleUrl: './copilot-followup-questions-message.component.scss'
})
export class CopilotFollowupQuestionsMessageComponent {
  @Input() followUpQuestions: string[] | undefined;
  @Input() sendMessage!: string | null;
  copilotService = inject(CopilotService);
  questionAsked = false;
  selectedQuestion = '';

  public sendQuestion(question: string) {
    if (!this.questionAsked) {
      this.selectedQuestion = question;
      this.copilotService.addUserMessage(this.sendMessage as string, question);
      this.questionAsked = true;
    }
  }

}
